import React, { Component } from 'react';
import Chart from "react-apexcharts";
import Loader from '../Common/Loader';
import ajaxBank from '../../util/remote/ajaxBank';

class PMTransactionsCategorizedChart extends Component {

    state = {
        testing: false,
        statData: false,
        series: [],
        options: {}
    };

    setSeries = (collections) => {
        this.setState({
          series: [
            {
              name: 'Student Deposits',
              type: 'line',
              data: collections.deposit
            },
            {
              name: 'Canteen Purchases',
              type: 'line',
              data: collections.purchase
            },
            {
              name: 'Student Withdrawals',
              type: 'line',
              data: collections.withdraw
            },
            {
              name: 'Pocket Money Conversions',
              type: 'line',
              data: collections.conversion
            },
            {
              name: 'Card Activations',
              type: 'line',
              data: collections.card_activation
            },
            {
              name: 'Wristband Activations',
              type: 'line',
              data: collections.wristband_activation
            }
          ]
        });
    };

    setOptions = (months) => {
        this.setState({
          options: {
            chart: {
              type: 'line', 
            //   stacked: true,
              toolbar: {
                show: false
              }
            },
            plotOptions: {
              bar: {
                columnWidth: '90%' ,
                horizontal: false,

              }
            },
            colors: ['#4F8EF7', '#F76E6C', '#43E794', '#FFD166', '#9B51E0', '#00B8A9'],
            stroke: {
              width: [3, 3, 3, 3, 3, 3], // Set stroke width for each series
              curve: 'smooth' 
            },
            fill: {
              opacity: [1, 1, 1, 1, 1, 1], // Set different opacity for each series
              
            },
            labels: months, // Set the labels as months
            markers: {
              size: 0
            },
            yaxis: {
              title: {
                display: false
              },
              min: 0,
              tickAmount: 7
            },
            legend: {
              display: false,
              position: 'top'
            },
            tooltip: {
              shared: true,
              intersect: false,
              y: {
                formatter: function (y) {
                  if (typeof y !== "undefined") {
                    return "UGX. " + y.toFixed(0); // Fix the concatenation here
                  }
                  return y;
                }
              }
            },
            grid: {
              borderColor: '#f1f1f1'
            }
          }
        });
    };
  

    getPMCollectionsCategorized = async () => {
        const server_response = await ajaxBank.fetchPMTransactionsCategorized();
        if (server_response.status === 'OK') {
          this.setState(
            {
              statData: server_response.details,
            },
            () => {
              const data = this.state.statData;
              const months = [];
              const collections = {
                deposit: [],
                purchase: [],
                withdraw: [],
                conversion: [],
                card_activation: [],
                wristband_activation: []
                
                
              };
      
              // Loop through the months and collect the totals
              Object.keys(data.months).forEach((index) => {
                months.push(data.months[index]);
                // Initialize the totals for each category for the current month
                const depositTotal = data.totals.deposit[index] ? data.totals.deposit[index].total * 1 : 0;
                const purchaseTotal = data.totals.purchase[index] ? data.totals.purchase[index].total * 1 : 0;
                const withdrawTotal = data.totals.withdraw[index] ? data.totals.withdraw[index].total * 1 : 0;
                const conversionTotal = data.totals.conversion[index] ? data.totals.conversion[index].total * 1 : 0;
                const cardActivationTotal = data.totals.card_activation[index] ? data.totals.card_activation[index].total * 1 : 0;
                const wristbandActivationTotal = data.totals.wristband_activation[index] ? data.totals.wristband_activation[index].total * 1 : 0;
                
      
                // Push the totals into the corresponding category array
                collections.deposit.push(depositTotal);
                collections.purchase.push(purchaseTotal);
                collections.withdraw.push(withdrawTotal);
                collections.conversion.push(conversionTotal);
                collections.card_activation.push(cardActivationTotal);
                collections.wristband_activation.push(wristbandActivationTotal);
                
                
              });
      
              // Set options for months
              this.setOptions(months);
      
              // Set series data for the categories
              this.setSeries(collections);
            }
          );
        }
    };

    componentDidMount() {
        this.getPMCollectionsCategorized()
    }

    render() {
        return (<>
                <div className="card-option d-flex">
                <div>
                    <h6 className="card-title mb-1">Pocket Money Collections</h6>
                    <p className="text-muted card-sub-title">Total volume of pocket money transactions according to the different categories each month</p>
                </div>
                <div className="card-option-title ml-auto">
                    <div className="btn-group p-0">
                    
                    <button className="btn btn-light btn-sm" type="button">This Year</button>
                                    
                    </div>
                </div>
                </div>
                <div>

                {this.state.statData && this.state.options && this.state.series && <Chart
                                                                                        options={this.state.options}
                                                                                        series={this.state.series}
                                                                                        height={300}
                                                                                    /> }
                {!this.state.statData && <Loader/>}

                </div></>
            
        );
    }
}

export default PMTransactionsCategorizedChart;